import ApiService from './ApiService'

export default class GeneralService {
  constructor() {
    this.apiService = new ApiService()
  }

  async getStandardEquipmentsByInstitution(institutionId) {
    const response = await this.apiService.get(
      `standardEquipment/list/${institutionId}`,
      true,
      false
    )

    return response.content
  }

  async getStandardEquipments() {
    const response = await this.apiService.get(
      `standardEquipment/list`,
      true,
      false
    )
    return response.content
  }
}
